import React from 'react';
import { IProps } from './type';

const SortListIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 5L8.6445 4.64841C8.73842 4.55344 8.86643 4.5 9 4.5C9.13357 4.5 9.26158 4.55344 9.3555 4.64841L9 5ZM9.5 16.375C9.5 16.6511 9.27614 16.875 9 16.875C8.72386 16.875 8.5 16.6511 8.5 16.375L9.5 16.375ZM5.6445 7.68174L8.6445 4.64841L9.3555 5.35159L6.3555 8.38493L5.6445 7.68174ZM9.3555 4.64841L12.3555 7.68174L11.6445 8.38493L8.6445 5.35159L9.3555 4.64841ZM9.5 5L9.5 16.375L8.5 16.375L8.5 5L9.5 5Z"
        fill={fillColor ? fillColor : "#212121"} />
      <path
        d="M15 19L14.6445 19.3516C14.7384 19.4466 14.8664 19.5 15 19.5C15.1336 19.5 15.2616 19.4466 15.3555 19.3516L15 19ZM15.5 7.625C15.5 7.34886 15.2761 7.125 15 7.125C14.7239 7.125 14.5 7.34886 14.5 7.625L15.5 7.625ZM11.6445 16.3183L14.6445 19.3516L15.3555 18.6484L12.3555 15.6151L11.6445 16.3183ZM15.3555 19.3516L18.3555 16.3183L17.6445 15.6151L14.6445 18.6484L15.3555 19.3516ZM15.5 19L15.5 7.625L14.5 7.625L14.5 19L15.5 19Z"
        fill={fillColor ? fillColor : "#212121"} />
    </svg>
  )
};

export default SortListIcon;
